import { useState, useEffect } from 'react';
import { ThemeService } from '../services/themeService';

export const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useState<string>(() => ThemeService.getCurrentTheme());

  useEffect(() => {
    // Apply theme on mount
    ThemeService.applyTheme(currentTheme);
  }, [currentTheme]);

  const changeTheme = (themeId: string) => {
    setCurrentTheme(themeId);
    ThemeService.setTheme(themeId);
  };

  const getCurrentThemeTemplate = () => {
    return ThemeService.getThemeById(currentTheme);
  };

  const getAvailableThemes = () => {
    return ThemeService.getAvailableThemes();
  };

  return {
    currentTheme,
    changeTheme,
    getCurrentThemeTemplate,
    getAvailableThemes,
  };
};
